import { render, staticRenderFns } from "./waitPay.vue?vue&type=template&id=360abf2f&scoped=true"
import script from "./waitPay.vue?vue&type=script&lang=js"
export * from "./waitPay.vue?vue&type=script&lang=js"
import style0 from "./waitPay.vue?vue&type=style&index=0&id=360abf2f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "360abf2f",
  null
  
)

export default component.exports